module.exports = __webpack_public_path__ + "img/dlt_kind_6.b2f36fcf.svg";